<app-main-header></app-main-header>
<router-outlet></router-outlet>
<footer class="footer mt-auto">
   <div class="container">
      <div class="row flmid">
         <div class="col-auto">
            <p class="copyright clearfix m-0">
               &copy;&nbsp;{{currentYear}}&nbsp;<span translate>lblCopyRight</span> <a href="https://www.autofacets.com/" class="clrblue"> AutoFacets</a>
               <span class="d-none d-sm-inline-block">, <span translate>lblAllRightReserved</span></span> 
               <!-- version
               : 1.0 -->
            </p>
         </div>
         <div class="col-auto ml-auto powered-text">
            <div class="flmid">
               <span translate>lblPoweredBy</span> <img class="brand" src="./../../../assets/images/afx/header-logo.svg" height="25" 
                  alt="Logo" />
            </div>

         </div>
      </div>
   </div>
</footer>